import { makeContext } from "@shared/utils/makeContext";

// --- Name ---
const NAME = "MobileMenu";

// --- State & Actions ---
export type MobileMenuState = {
  isOpen: boolean;
};

export const MOBILE_MENU_OPEN = "mobileMenu/open";
export const MOBILE_MENU_CLOSE = "mobileMenu/close";

export const ACTION_TYPES = {
  MOBILE_MENU_OPEN,
  MOBILE_MENU_CLOSE,
} as const;

export type MobileMenuAction =
  | { type: typeof MOBILE_MENU_OPEN }
  | { type: typeof MOBILE_MENU_CLOSE };

const initialMobileMenuState: MobileMenuState = {
  isOpen: false,
};

// --- Reducer ---
function mobileMenuReducer(
  state: MobileMenuState,
  action: MobileMenuAction
): MobileMenuState {
  switch (action.type) {
    case MOBILE_MENU_OPEN:
      return {
        isOpen: true,
      };
    case MOBILE_MENU_CLOSE:
      return {
        isOpen: false,
      };
    default:
      throw new Error(`Unknown action: ${action.type}`);
  }
}
// --- Generate Context ---
export const {
  Provider: MobileMenuProvider,
  useState: useMobileMenuState,
  useDispatch: useMobileMenuDispatch,
} = makeContext<MobileMenuState, MobileMenuAction>({
  name: NAME,
  reducer: mobileMenuReducer,
  initialState: initialMobileMenuState,
});
